export function backgroundParallax() {
    let layers = document.querySelectorAll("[data-type='parallax']");
    let isSectionVisible = false;

    $(document).scroll(function() {
        for (let i = 0; i < layers.length; i++) {
            let depth = layers[i].getAttribute('data-depth');
            parallaxBackground(layers[i], depth);
        }


        if ($(window).width() > 1200) {
            if (isSectionVisible) {
                parallaxImage();
            }
        }
    });

    let callback = function (entries) {
        let entry = entries[0];
        isSectionVisible = entry.isIntersecting;
    };

    let observer = new IntersectionObserver(callback);

    let target = document.querySelector('.subscribe');
    observer.observe(target);



    function parallaxBackground(domElement, depth) {
        depth = depth || 0.2;
        const topDistance = window.pageYOffset;
        const movement = -(topDistance * depth);
        const translate3d = 'translate3d(0, ' + movement + 'px, 0)';

        domElement.style['-webkit-transform'] = translate3d;
        domElement.style['-moz-transform'] = translate3d;
        domElement.style['-ms-transform'] = translate3d;
        domElement.style['-o-transform'] = translate3d;
        domElement.style.transform = translate3d;
    }

    function parallaxImage() {
        let scrolled = $(window).scrollTop();

        let container = $(".subscribe")[0];
        let imgRight = $(".subscribe .image-right")[0];
        let imgLeft = $(".subscribe .image-left")[0];

        let intersectionPointTop = scrolled + container.offsetHeight - container.offsetTop;
        let newTop = intersectionPointTop * 0.8 ;
        if(newTop + imgRight.offsetHeight > container.offsetHeight) {
            newTop = container.offsetHeight - imgRight.offsetHeight;
        }

        if(newTop + imgLeft.offsetHeight > container.offsetHeight) {
            newTop = container.offsetHeight - imgLeft.offsetHeight;
        }

        imgRight.style.top = newTop + "px";
        imgLeft.style.top = newTop + "px";

    }

}


// WEBPACK FOOTER //
// ./assets/js/modules/background-parallax.js